<template>
  <div class="container">
    <div class="top-nav">
      <div class="main-nav">
        <div class="back-btn"><a href="http://lp2024-navi-en.wirechina.net" target="_blank"><span
              class="iconfont icon-fanhui"></span>&nbsp;Back</a></div>
        <div class="right-text">
          <span class="nav-date">2024.9.25 - 28</span>
          <span class="nav-address">&nbsp;| Shanghai New International Expo Centre</span>
        </div>
        <div class="clear-both"></div>
      </div>
    </div>

    <div class="top-title">
      <div class="left-logo">
        <img src="../assets/img/tube_logo.png" />
      </div>
      <div class="top-title-text">
        The 11<sup>th</sup> – International Tube & Pipe Industry Trade Fair<br>
        (Tube China 2024)
      </div>
      <div class="right-logo">
        <img src="../assets/img/tube_header_alt.jpg" />
      </div>
      <div class="clear-both"></div>
    </div>

    <div class="mod-1">
      <div class="mod-1-left">
        After 20 years, Tube China has not only become Asia's leading tube and pipe industry exhibition, but also a
        pioneer in the industry. The organizers Messe Düsseldorf (Shanghai) Co., Ltd. and MC-CCPIT will leverage their
        respective advantages to promote technological innovation, green and intelligent transformation, focus on
        industry trending topics and provide a brand-new upgraded trade platform to present the state-of-the-art
        products, technologies and solutions from a professional perspective.
      </div>
      <div class="mod-1-img">
        <img src="../assets/img/tube_landing_01.png" />
        <div class="mod-1-img-descp">2024.9.25-28 | Shanghai New International Expo Centre</div>
      </div>
      <div class="clear-both"></div>
    </div>

    <div class="mod-2">
      <a :href="boothUrl" target="_blank">
        <div class="mod-2-btn1">Booth Application</div>
      </a>
      <a :href="visitorUrl">
        <div class="mod-2-btn2">Visitor Registration</div>
      </a>
      <div class="clear-both"></div>
    </div>

    <div class="mod-3">
      <div class="mod-3-mengban">
        <div class="img-bg">
          <img src="../assets/img/tube_landing_02.png" />
        </div>
        <div class="img-bg2">
          <div class="mod-3-1">
            <div>
              <span class="mod-3-big">Exhibition Space</span>
              <div class="hengxian"></div>
              <AnimatedNumber :targetValue="20000" :duration="1000" suffix="㎡" customClass="mod-3-small" />
            </div>
          </div>
          <div class="mod-3-2">
            <div>
              <span class="mod-3-big">Professional Visitors</span>
              <div class="hengxian"></div>
              <AnimatedNumber :targetValue="22365" :duration="1000" suffix="" customClass="mod-3-small" />
              <!-- <span class="mod-3-small">40629</span> -->
            </div>
          </div>
          <div class="mod-3-3">
            <div>
              <span class="mod-3-big">Exhibitors</span>
              <div class="hengxian"></div>
              <AnimatedNumber :targetValue="390" :duration="1000" suffix="+" customClass="mod-3-small" />
              <!-- <span class="mod-3-small">900+</span> -->
            </div>
          </div>
          <div class="clear-both"></div>
        </div>
      </div>
    </div>

    <div class="mod-4">* Data source: Tube China 2023</div>

    <div class="mod-5">
      <div class="padding60"></div>
      <div class="mod-5-1">
        <div class="mod-5-1-left">
          <img src="../assets/img/tube_landing_03.jpg" />
        </div>

        <div class="mod-5-1-right">
          <div class="mod-5-1-right-1">
            <img src="../assets/img/tube_landing_04.jpg" />
          </div>
          <div class="mod-5-1-right-2">
            <img src="../assets/img/tube_landing_05.jpg" />
          </div>
        </div>

        <div class="clear-both"></div>
      </div>

      <!-- 展品 -->
      <div class="mod-5-2">
        <div class="mod-5-2-1">
          <div class="mod-5-2-1-title">Product Category</div>
          <div class="hengxian-red"></div>
          <div class="mod-5-2-1-fanwei">
            <div class="mod-5-2-1-item" v-for="(item, index) in fanwei" :key="index">
              <div class="icon float-left"></div>
              <div class="mod-5-2-icon-text float-left">{{item}}</div>
              <div class="clear-both"></div>
            </div>
          </div>
        </div>
        <div class="mod-5-2-2">
          <div class="mod-5-2-1-title">Target Visitor</div>
          <div class="hengxian-red"></div>
          <div class="mod-5-2-1-fanwei">
            <div class="mod-5-2-1-fanwei-1">
              <div class="mod-5-2-1-item" v-for="(item, index) in mubiao" :key="index">
                <div class="icon float-left"></div>
                <div class="mod-5-2-icon-text float-left">{{item}}</div>
                <div class="clear-both"></div>
              </div>
            </div>
            <!-- <div class="mod-5-2-1-fanwei-2">
              <div class="mod-5-2-1-item" v-for="(item, index) in mubiao2" :key="index">
                <div class="icon float-left"></div>
                <div class="mod-5-2-icon-text float-left">{{item}}</div>
                <div class="clear-both"></div>
              </div>
            </div> -->

            <div class="clear-both"></div>
          </div>
        </div>

        <div class="clear-both"></div>
      </div>
    </div>

    <!--  展位按钮 -->
    <div class="mod-6">
      <div>
        <a :href="boothUrl" target="_blank">
          <div class="mod-6-1">Booth Application</div>
        </a>
        <a :href="visitorUrl">
          <div class="mod-6-2">Visitor Registration</div>
        </a>
        <div class="clear-both"></div>
        <div class="mod6-img-box">
          <div class="mod-6-img">
            <img src="../assets/img/tube_landing_06.jpg" />
          </div>
          <div class="mod-6-img">
            <img src="../assets/img/tube_landing_07.jpg" />
          </div>
          <div class="mod-6-img">
            <img src="../assets/img/tube_landing_08.jpg" />
          </div>
        </div>
      </div>
      <div class="padding60"></div>
    </div>

    <div class="mod-7">
      <div class="padding60"></div>
      <div class="mod-7-1">
        <div class="mod-7-title">Industry Giants Gather Together</div>
        <div class="mod-t-red-hengxian"></div>
        <div class="mod-7-imgages">
          <div class="mod-7-img-item" v-for="(item, index) in zsImg" :key="index"
            :style="{ 'margin-right': shouldApplyMargin(index) ? '0' : '15' }">
            <img :src="item" />
          </div>
          <div class="clear-both"></div>
        </div>
      </div>

      <div class="padding60"></div>
      <div class="mod-7-1">
        <div class="mod-7-title">Well-known Buyers and Delegations</div>
        <div class="mod-t-red-hengxian"></div>
        <div class="mod-7-imgages">
          <div class="mod-7-img-item" v-for="(item, index) in mjImg" :key="index"
            :style="{ 'margin-right': shouldApplyMargin(index) ? '0' : '15' }">
            <img :src="item" />
          </div>
          <div class="clear-both"></div>
        </div>
      </div>
    </div>

    <div class="mod-8">
      <img src="../assets/img/tube_landing_09.jpg" />
    </div>
    <div class="mod-9">
      <div>wire & Tube Global Network</div>
      <div class="mod-t-red-hengxian"></div>
    </div>
    <div class="mod-10">
      <img src="../assets/img/wire_landing_10_en.jpg" />
    </div>

    <div class="mod-bottom">
      <div class="padding60"></div>
      <div class="mod-bottom-main">
        <div class="mod-bottom-1">
          <div class="mod-bottom-1-title">Organizers</div>
          <div class="hengxian-fff"></div>
          <div class="mod-bottom-logo1">
            <img src="../assets/img/footer_logo_dusseldorf.png" />
          </div>
          <div class="mod-bottom-logo2">
            <img src="../assets/img/footer_logo_mc.png" />
          </div>
        </div>

        <div class="mod-bottom-2">
          <div class="mod-bottom-2-title">Contact</div>
          <div class="hengxian-fff"></div>
          <div class="mod-bottom-2-mian">
            <div class="mod-bottom-2-contact">
              <div><span class="iconfont icon-kehu icon-zhanwei"></span>Mr. Sam Xu</div>
              <div><span class="iconfont icon-dianhua1 icon-zhanwei"></span>+86 21 6169 8374</div>
              <div><span class="iconfont icon-youxiang icon-zhanwei"></span>sam.xu@mds.cn</div>
            </div>
            <div class="mod-bottom-2-contact marginLeft60">
              <div><span class="iconfont icon-kehu icon-zhanwei"></span>Ms. Mary Cao</div>
              <div><span class="iconfont icon-dianhua1 icon-zhanwei"></span>+86 21 6169 8369</div>
              <div><span class="iconfont icon-youxiang icon-zhanwei"></span>mary.cao@mds.cn</div>
            </div>
            <div class="clear-both"></div>
          </div>
        </div>

        <div class="mod-bottom-3">
          <img src="../assets/img/footer_linkedin.png" />
        </div>

        <div class="clear-both"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import AnimatedNumber from './AnimatedNumber.vue';
  import '../assets/font/iconfont.css';
  import '../assets/css/common.scss';
  import axios from 'axios';
  export default {
    name: 'tubeEN',
    components: {
      AnimatedNumber
    },
    data() {
      return {
        boothUrl: "https://www.tubechina.net/links?id=288",
        visitorUrl: "https://www.tubechina.net/links?id=289",
        fanwei: [
          'Raw Materials / Tubes / Accessories',
          'Tube Manufacturing Machinery',
          'Heat Treatment Processing and Machinery (UPGRADED)',
          'Rebuilt / Reconditioned Machinery',
          'Sawing and Laser Cutting Machinery (UPGRADED)',
          'Process Technology tools / Auxiliaries',
          'Measuring / Control Technology',
          'Testing Engineering',
          'Specialist Areas',
          'Trading / Stockists of Tubes',
          'Pipeline / OCTG Technology',
          'Profiles / Machinery',
          'Plastic Tube and Compound Pipe',
          'Others'
        ],
        mubiao: [
          'Tube Industry',
          'lron Steel / Non-ferrous Metal Industry',
          'Automotive Supply Industry',
          'Electrical Industry',
          'Construction Industry',
          'Chemical Industry',
          'Oil / Gas Industry',
          'Instrumentation Testing & Measuring',
          'Electronic Industry',
          'Energy / Water Supply Industry',
          'Aerospace Engineering',
          'Others'
        ],
        zsImg: [
          require('../assets/img/tube_ex/ex_logo_01.jpg'),
          require('../assets/img/tube_ex/ex_logo_02.jpg'),
          require('../assets/img/tube_ex/ex_logo_03.jpg'),
          require('../assets/img/tube_ex/ex_logo_04.jpg'),
          require('../assets/img/tube_ex/ex_logo_05.jpg'),
          require('../assets/img/tube_ex/ex_logo_06.jpg'),
          require('../assets/img/tube_ex/ex_logo_07.jpg'),
          require('../assets/img/tube_ex/ex_logo_08.jpg'),
          require('../assets/img/tube_ex/ex_logo_09.jpg'),
          require('../assets/img/tube_ex/ex_logo_10.jpg'),
          require('../assets/img/tube_ex/ex_logo_11.jpg'),
          require('../assets/img/tube_ex/ex_logo_12.jpg'),
          require('../assets/img/tube_ex/ex_logo_13.jpg'),
          require('../assets/img/tube_ex/ex_logo_14.jpg'),
          require('../assets/img/tube_ex/ex_logo_15.jpg'),
          require('../assets/img/tube_ex/ex_logo_16.jpg'),
          require('../assets/img/tube_ex/ex_logo_17.jpg'),
          require('../assets/img/tube_ex/ex_logo_18.jpg'),
          require('../assets/img/tube_ex/ex_logo_19.jpg'),
          require('../assets/img/tube_ex/ex_logo_20.jpg'),
          require('../assets/img/tube_ex/ex_logo_21.jpg'),
          require('../assets/img/tube_ex/ex_logo_22.jpg'),
          require('../assets/img/tube_ex/ex_logo_23.jpg'),
          require('../assets/img/tube_ex/ex_logo_24.jpg')
        ],
        mjImg: [
          require('../assets/img/tube_buyer/buyer_logo_01.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_02.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_03.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_04.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_05.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_06.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_07.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_08.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_09.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_10.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_11.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_12.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_13.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_14.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_15.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_16.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_17.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_18.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_19.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_20.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_21.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_22.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_23.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_24.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_25.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_26.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_27.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_28.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_29.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_30.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_31.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_32.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_33.jpg'),
          require('../assets/img/tube_buyer/buyer_logo_34.jpg')
        ]
      }
    },
    methods: {
      shouldApplyMargin(index) {
        return (index + 1) % 5 === 0;
      },
      parseQueryString(url) {
        var obj = {}
        var keyvalue = []
        var key = ''
        var value = ''
        var paraString = url.substring(url.indexOf('?') + 1, url.length).split('&')
        for (var i = 0; i < paraString.length; i++) {
          keyvalue = paraString[i].split('=')
          key = keyvalue[0]
          value = keyvalue[1]
          obj[key] = value
        }
        return obj
      },

      postData() {
        const queryString = this.parseQueryString(this.$route.fullPath)
        const params = {
          source: queryString.source,
          url: 'lp2024-en.tubechina.net'
        }
        const res = axios.post('http://wirechina_api.maxdigi.cn/api/log', params)
        res.then(response => {
          console.log('请求成功:')
          console.log('respnse', response)
        })
      }
    },
    mounted() {
      this.postData()
      const queryString = this.parseQueryString(this.$route.fullPath)
      if (queryString.utm_source == "google_sem") {
        this.boothUrl = 'https://www.tubechina.net/links?id=334'
        this.visitorUrl = 'https://www.tubechina.net/links?id=333'
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  /* 适配手机端，调整字体大小和元素大小等 */
  @media screen and (max-width: 767px) {
    @import '../assets/css/style-mobile.scss'
  }

  /* 适配大屏幕设备（桌面电脑） */
  @media screen and (min-width: 768px) {
    @import '../assets/css/style.scss'
  }
</style>



// WEBPACK FOOTER //
// src/components/tube-en.vue